module.exports = __webpack_public_path__ + "static/img/hesuanjiance.5131c73f.png";